import React, { FC } from 'react'

const CardIcon: FC = () => (
  <svg width="20" height="16" viewBox="0 0 20 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M5.94513 0.167736C7.098 0.0676394 8.45045 0 10.0004 0C11.5497 0 12.9018 0.067591 14.0545 0.167628C16.0797 0.343396 17.0924 0.43128 18.3818 1.7253C19.1601 2.50628 19.4981 3.16952 19.6793 3.99951H0.321627C0.502832 3.1695 0.840783 2.50629 1.61924 1.72517C2.90861 0.431378 3.92078 0.343497 5.94513 0.167736Z"
      fill="currentColor"
    />
    <path
      d="M0.0814631 5.99951C0.0307472 6.62845 0 7.29888 0 8.00004C0 8.7272 0.0330711 9.42131 0.0871902 10.0704C0.24899 12.0109 0.329891 12.9811 1.61924 14.2749C2.90858 15.5687 3.92071 15.6565 5.94497 15.8323C7.09787 15.9324 8.45038 16.0001 10.0004 16.0001C11.5498 16.0001 12.902 15.9325 14.0547 15.8324C16.0798 15.6566 17.0924 15.5687 18.3818 14.2747C19.6713 12.9807 19.7521 12.01 19.9137 10.0685C19.9677 9.41999 20.0007 8.72651 20.0007 8.00004C20.0007 7.29888 19.97 6.62845 19.9193 5.99951H0.0814631Z"
      fill="currentColor"
    />
  </svg>
)

export default CardIcon
